import { ReactElement } from 'react';
import cx from 'clsx';
import { Sprinkles } from '@ff-it/ui';
import { TitleContainer, Title, SubTitle, TitleContainerProps } from 'components/TitleContainer';
import { genericProduct } from './style.css';
import type { EmbeddedProduct } from '..';

export type ProductTitleProps = {
  product: Pick<EmbeddedProduct, 'id' | 'name' | 'outlet_or_service_category' | 'disabled'>;
  className?: string;
  size?: TitleContainerProps['size'];
} & Sprinkles;

export function ProductTitle({
  product: { id, name, outlet_or_service_category: oosc, disabled },
  className,
  size,
  ...rest
}: ProductTitleProps): ReactElement {
  const mediaTitle = oosc.vendor && oosc.vendor.name !== oosc.name ? `${oosc.vendor.name} / ${oosc.name}` : oosc.name;
  return (
    <TitleContainer
      className={cx('product-title', className)}
      data-testid={`product-${id}`}
      disabled={disabled}
      {...rest}
    >
      <Title className="outlet-or-service-category" size={size} title={mediaTitle}>
        {mediaTitle}
      </Title>
      <SubTitle className={cx('product', { [genericProduct]: !name })} size={size}>
        {name || 'Generic product'}
      </SubTitle>
    </TitleContainer>
  );
}
